module.exports = __webpack_public_path__ + "img/kommune-1417.79affc3c.svg";